import { CheckCircleTwoTone, CopyOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Divider, Space, Typography, message } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const WalletActivated = ({
  form,
  onContinue,
  onFormChange,
  formValues,
  onChangeFormValues,
}) => {
  const navigate = useNavigate();
  const handleCopy = () => {
    navigator.clipboard.writeText("8488239780");
    message.success("Account number copied!");
  };

  const navigateDasboard = () => {
    navigate("/walletDashboard");
  };

  return (
    <Card
      style={{
        marginTop: 24,
        width: "100%",
        maxWidth: 400,
        maxHeight: "80vh", // Restrict height
        overflowY: "auto", // Enable vertical scrolling
      }}
      bodyStyle={{ padding: 24 }}
    >
      <div style={{ maxHeight: "70vh", overflowY: "auto", paddingRight: 8 }}>
        <div style={{ textAlign: "center" }}>
          <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 48 }} />
          <Title level={4} style={{ marginTop: 10 }}>
            Wallet Activated! 🎉
          </Title>
          <Text type="secondary">Your Wallet Pro account is ready to use</Text>
        </div>

        <Divider />

        <div
          style={{
            padding: 16,
            background: "#fafafa",
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            marginBottom: 16,
          }}
        >
          <Title level={5}>Your Account</Title>
          <Text>
            <strong>Account Name : </strong> {formValues.name}
          </Text>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 8,
            }}
          >
            <Text>
              <strong>Account Number : </strong>
              {formValues.accountNumber}
            </Text>
            <Button size="small" icon={<CopyOutlined />} onClick={handleCopy}>
              Copy
            </Button>
          </div>
          <Text style={{ display: "block", marginTop: 10 }}>
            <strong>Bank Name:</strong> Wallet Pro Microfinance Bank
          </Text>
        </div>

        <Space
          direction="horizontal"
          style={{ width: "100%", justifyContent: "space-between" }}
        >
          <div style={{ textAlign: "center" }}>
            <Title level={5} style={{ margin: 0 }}>
              {formValues.nationality === "Indian" ? "₹" : "$"}&nbsp; 0.00
            </Title>
            <Text type="secondary">
              {formValues.nationality === "Indian"
                ? "INR"
                : formValues.nationality === "Canadian"
                ? "CAD"
                : "USD"}{" "}
              Balance
            </Text>
          </div>
          <div style={{ textAlign: "center" }}>
            <Title level={5} type="success" style={{ margin: 0 }}>
              ✔
            </Title>
            <Text type="success">Verified</Text>
          </div>
        </Space>
        <Alert
          message={
            <>
              <Title level={5}>🎁 Welcome Bonus</Title>
              <Text>
                You'll receive ₦100 bonus credit when you complete your first
                transaction!
              </Text>
            </>
          }
          type="warning"
          style={{ marginTop: 16 }}
        />

        <Alert
          message={
            <>
              <Title level={5}>Ready to start?</Title>
              <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                <li>Your wallet is active and ready</li>
                <li>You can receive money immediately</li>
                <li>Fund your wallet to start sending money</li>
                <li>Complete ID verification for higher limits</li>
              </ul>
            </>
          }
          type="info"
          style={{ marginTop: 16 }}
        />

        <Button
          type="primary"
          size="large"
          block
          className="mt-4 mb-3"
          style={{
            background: "linear-gradient(to right, #1d4ed8, #a7f3d0)", // blue to light green
            border: "none", // optional, remove border if desired
          }}
          onClick={navigateDasboard}
        >
          Go to Dashboard
        </Button>
      </div>
    </Card>
  );
};

export default WalletActivated;
